/* ==================================================================
   Gallery lightbox for the "Recently arranged" / "Inspiration" rails.

   Matt, 2026-09-30: those products are not for sale, they are a
   gallery. A tile opens the photograph over the page instead of
   navigating to a product page.

   Scoped per section: each `.fs-products` that has a
   [data-fs-lightbox] gets its own instance over its own tiles, so
   "In stock" on the same page is untouched.
   ================================================================== */
(function () {
  'use strict';

  function init(section) {
    var box = section.querySelector('[data-fs-lightbox]');
    var tiles = Array.prototype.slice.call(section.querySelectorAll('[data-fs-zoom]'));
    if (!box || !tiles.length) return;

    var img     = box.querySelector('.fs-lightbox__img');
    var caption = box.querySelector('.fs-lightbox__caption');
    var prevBtn = box.querySelector('[data-fs-prev]');
    var nextBtn = box.querySelector('[data-fs-next]');
    var closeBtn= box.querySelector('[data-fs-close]');
    var index   = 0;
    var opener  = null;
    var single  = tiles.length < 2;

    if (single) { prevBtn.hidden = true; nextBtn.hidden = true; }

    function show(i) {
      index = (i + tiles.length) % tiles.length;
      var t = tiles[index];
      var w = parseInt(t.getAttribute('data-w'), 10);
      var h = parseInt(t.getAttribute('data-h'), 10);
      /* Set the intrinsic ratio before the src so the frame does not
         jump from the previous photo's shape while the new one loads. */
      if (w && h) { img.width = w; img.height = h; }
      img.src = t.getAttribute('data-full');
      img.alt = t.getAttribute('data-alt') || '';
      /* The caption follows the section's own "Show title" setting —
         no separate switch. A gallery rail with titles turned off on
         the tiles should not grow one when the photo is enlarged. */
      var cap = t.getAttribute('data-caption') || '';
      caption.textContent = cap;
      caption.hidden = !cap;
    }

    function open(i, from) {
      opener = from || null;
      show(i);
      box.hidden = false;
      /* Two frames: the element must be laid out before the opacity
         transition has anything to animate from. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { box.classList.add('is-open'); });
      });
      document.documentElement.classList.add('fs-lightbox-open');
      closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      box.classList.remove('is-open');
      document.documentElement.classList.remove('fs-lightbox-open');
      document.removeEventListener('keydown', onKey);
      var done = function () {
        box.hidden = true;
        img.removeAttribute('src');
        box.removeEventListener('transitionend', done);
      };
      box.addEventListener('transitionend', done);
      /* transitionend never fires under prefers-reduced-motion. */
      setTimeout(done, 400);
      if (opener) opener.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (single) return;
      if (e.key === 'ArrowRight') { show(index + 1); }
      if (e.key === 'ArrowLeft')  { show(index - 1); }
    }

    tiles.forEach(function (t, i) {
      t.addEventListener('click', function () { open(i, t); });
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });

    /* Backdrop only — a click on the photo itself must not close it. */
    box.addEventListener('click', function (e) { if (e.target === box) close(); });

    /* Swipe, phones. 45px of travel and mostly horizontal, so a
       vertical flick does not count as a page turn. */
    var x0 = null, y0 = null;
    box.addEventListener('touchstart', function (e) {
      x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null || single) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('.fs-products').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
